import { createContext, useContext } from "react";

// The detail header's switcher slot. ScopedView offers the slot when its
// header is the compact one-line trace header; the panel that owns the reading
// switcher portals the switcher there, so the reading's state stays with the
// readings and only its buttons move.
export const DetailHeaderSlotContext = createContext(null);
export const useDetailHeaderSlot = () => useContext(DetailHeaderSlotContext);
